import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/ventures/save`,
        endpointGetById: `${endpointBackend}gci/ventures/getById`,
        endpointGetAllFileTypes: `${endpointBackend}gci/file-types/getall`,
        urlGoBack: `/gci/ventures/list`,
        pathView: `/gci/ventures/view`
    }

    const labels = {
        labelTitleEdit: "Repositório de Arquivos",
        labelTitleView: "Repositório de Arquivos"
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                {
                    name: 'files',
                    type: 'multiinput',
                    label: 'Arquivos',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Tipo',
                            type: 'select',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllFileTypes,
                                label: 'name',
                                value: 'id'
                            },
                            name: 'type',
                            validations: {
                                required: true
                            },
                            columnSize: 4
                        },
                        {
                            label: 'Arquivo',
                            type: 'fileS3',
                            name: 'file',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    }
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
